module.exports = __webpack_public_path__ + "static/img/fly-by-fire-lucre-games-lowpoly-landscape-poster.924422b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/fly-by-fire/fly-by-fire-lucre-games-lowpoly-landscape-poster.jpg
// module id = Ul09
// module chunks = 0